import styled from 'styled-components';
import { Slider, Input } from 'antd';

export const CustomSlider = styled(Slider)`
  .ant-slider-dot {
    top: -1px;
    width: 10px;
    height: 10px;
  }

  .ant-slider-handle {
    top: 3px;
  }
`;

export const DerivativesBodyWrapper = styled.div`
  height: auto;
`;

export const OrderValueInputSection = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 12px 12px 0 12px;

  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: flex-start;
  position: relative;
`;

export const Wrapper = styled.div`
  width: 100%;
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
  position: relative;
`;

export const PercentageFormWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  background-color: ${(props) => props.theme.COLORS.gray};
  justify-content: center;
  align-items: center;
  border-radius: 5px;
`;
export const QuantityCosts = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`;

export const CustomInput = styled(Input)`
  background-color: #2a2c2e;
  border-radius: 6;
  overflow: hidden;
  border: 1px solid transparent;
  box-sizing: border-box;
  height: 38px;
  padding: 4px 12px;
  width: 100%;

  font-family: 'NanumSquareRound' !important;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: -0.24;
  color: #fff;

  input {
    font-family: 'NanumSquareRound' !important;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: -0.24;
    color: #fff;
    line-height: normal;
  }

  .ant-input-suffix {
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: normal;
  }

  &:hover {
    background-color: #2a2c2e;
  }
`;
